import Pill from "carbon-react/esm/components/pill";

type StatusTone = "information" | "negative" | "neutral" | "positive" | "warning";

interface StatusPillProps {
  label: string;
  size?: "S" | "M" | "L" | "XL";
  tone?: StatusTone;
}

export function StatusPill({ label, size = "S", tone = "neutral" }: StatusPillProps) {
  return (
    <Pill colorVariant={tone} fill pillRole="status" size={size}>
      {label}
    </Pill>
  );
}